export const customMovementsSectionInitValue = {
  data: {
    customMovements: [],
    customMovementsTotal: 0,
    page: 1,
    rowsPerPage: 10,
    isLoadingCustomMovements: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
  },
};
